import React from "react";
import { EntityDescriptor } from "..";

export class EntityNumberDisplayed extends React.Component<{ed: EntityDescriptor, displayed: number, total: number}> {
    render() {
        return <p role="entityNumberDisplayed">{_msg("general.displaying", (this.props.displayed + " " + _msg({ pluralized: true }, this.props.ed.getLabelKey()).toLowerCase()), this.props.total)}</p>;
    }
}
